mutation UpdateCallRailIntegration($input: CallRailIntegrationUpdateInput!) {
    callRailIntegrationUpdate(input: $input) {
        callRailIntegration {
            isEnabledForUser
        }
    }
}
